import { selectFavouritesSummary, selectIsFavourite } from '@noths/polaris-client-user-favourites';
import { fetchWithTimeout } from '@noths/polaris-client-utils';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { FAVOURITE_ADDED_EVENT, FAVOURITE_REMOVED_EVENT } from '../constants/events';
import type { FavouritesSummary, StateWithFavourites } from '../types/favourites';
import type { NextConfig } from '../types/nextConfig';
import { actions as favouritesActions } from './slice';

const canOpenModal = ({ folderCount }: Pick<FavouritesSummary, 'folderCount'>) => folderCount > 0;

export type ThunkArg = {
  nextConfig: NextConfig;
  productCode: number;
};

export const updateFavourite = createAsyncThunk<number, ThunkArg>(
  'products/updateFavourite',
  async ({ nextConfig, productCode }, { dispatch, getState }) => {
    const state = getState() as StateWithFavourites;
    const favouritesSummary = selectFavouritesSummary(state);

    if (canOpenModal(favouritesSummary)) {
      dispatch(favouritesActions.openModal(productCode));
      return productCode;
    }

    const isFavourite = selectIsFavourite(favouritesSummary, productCode);
    const method = isFavourite ? 'DELETE' : 'PUT';

    await fetchWithTimeout(`${nextConfig.publicRuntimeConfig.endpoints.userList}/${productCode}`, {
      method,
      credentials: 'include',
      timeout: 3000,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`failed to ${isFavourite ? 'remove' : 'add'} favourite`);
        }
      })
      .then(() => {
        document.dispatchEvent(
          new Event(isFavourite ? FAVOURITE_REMOVED_EVENT : FAVOURITE_ADDED_EVENT),
        );
      });

    return productCode;
  },
);
